import React from 'react';

const MongoDB_match = () => {
  return (
    <div>
      <h1>MongoDB_match Component</h1>
      <p>This is the MongoDB_match page.</p>
    </div>
  );
};

export default MongoDB_match;
